import React, { useEffect, useState } from 'react'

import { Consent, getAccountConsents } from '../../../api/AccountConsent/getAccountConsents'
import { CheckboxConsent, ConsentCheckbox } from './Checkbox'

type ConsentCheckboxListProps = {
  accountId: string
}

export const ConsentCheckboxList: React.FC<ConsentCheckboxListProps> = ({ accountId }) => {
  const [consents, setConsents] = useState<CheckboxConsent[]>([])

  useEffect(() => {
    ;(async () => {
      const isAcceptedOrDeclined = (consent: Consent): boolean =>
        consent.status === 'Accepted' || consent.status === 'Declined'

      const accountConsents = await getAccountConsents(accountId)

      setConsents(accountConsents.filter(isAcceptedOrDeclined) as CheckboxConsent[])
    })()
  }, [])

  return (
    <>
      <div>
        <strong>Online advertenties</strong>
      </div>

      {consents.map((consent) => (
        <div key={consent.id}>
          <ConsentCheckbox accountId={accountId} consent={consent} />
        </div>
      ))}
    </>
  )
}
